import { Button, Switch } from "@material-ui/core";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import CircularProgress from "@mui/material/CircularProgress";
import styles from "../Accounts.module.scss";
import {
  calculateSubscriptionPayment,
  createNewSubscriptionAfterCancel,
  getAmounts,
  getCurrentPhase,
  getCustomerBalanceAmount,
  getPromotionCodes,
  getStripeConfigs,
  gettheSetupIntent,
  sendEmailForAchPaymentDetail,
  SuccesDownGradeEmail,
  SuccesUpdateSubscriptionEmail,
  updatePaymentVerification,
  UpdateStripeScheduleSubscription,
  UpgradeQuantitySubscription,
  UpgradeStripeSubscription,
} from "../../../services/apiservices/users";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import AuthContext from "../../../hooks/authContext";
import { STRIPE_PUBLISHABLE_KEY } from "../../../services/config";
import { withStyles } from "@material-ui/core/styles";
import PaymentFlowContet from "./PaymentFlowContet";
import CommonContext from "../../../hooks/commonContext";
import FeatureComparison from "./Features";
import TestimonialPage from "./Testimonial";
import { CommonConfirmationDialog, DownGradeDiaog } from "../../../components/DialogComponent/SupplyDataDialog";
import PaymentSuccess, { SuccessDowngradeDialog } from "./PaymentSuccess";
import { useToast } from "../../../hooks/useToast";
import SubscriptionList from "./SubscriptionList";
import PageTitle from "../../../components/pageTitle/PageTitle";
import { useMediaQuery } from "@mui/material";
import ACHVerification from "./ACHverification";
import PaymentMethodsList from "./PaymentMethodsList";
import { getAllProducts } from "../../../services/apiservices/settings";

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    "&$checked": {
      transform: "translateX(12px)",
      color: theme.palette.common.white,
      "& + $track": {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: "none",
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}))(Switch);

const UpgradePage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [prices, setPrices] = useState();
  const [yearlyPrice, setYearlyPrices] = useState();
  const [name, setName] = useState();
  // eslint-disable-next-line no-unused-vars
  const [stripe, setStripe] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [elements, setElements] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const [newAmounts, setNewAmounts] = useState();
  // eslint-disable-next-line no-unused-vars
  const cardRef = useRef();
  // eslint-disable-next-line no-unused-vars
  const messagesRef = useRef();
  const auth = useContext(AuthContext);
  const commonContext = useContext(CommonContext);
  const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [isAnnual, setIsAnnual] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [downgradeDialog, setDownGradeDialog] = useState(false);
  const [message, setMessage] = useState("");
  const [newPrice, setNewPrice] = useState(null);
  const [newProduct, setNewProduct] = useState(null);
  const [code, setCode] = useState();
  const [newPriceId, setNewPriceId] = useState(null);
  const [priceState, setPriceState] = useState();
  const [numUsers, setNumUsers] = useState(1);
  const [downgradeDetailsDialog, setDowngradeDetailsDialog] = useState(false);
  const [subChangeDialog, setSubChangeDialog] = useState(false);
  const [verificationLoader, setVerificationLoader] = useState(false);
  const [customerBalance, setCustomerBalance] = useState();
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [details, setDetails] = useState(null);
  const [verificationRequired, setVerificationRequired] = useState({});
  const [selectedPaymentmethodId, setSelectedPaymentMethodId] = useState({});
  const [isProcessing, setIsProcessing] = useState(false);
  const [isFullDiscount, setIsFullDiscount] = useState(false);
  const [planInfo, setPlanInfo] = useState({planName: null, description: null, amount: null, yearly: false});
  const [existingPaymentMethod, setExistinPaymentMethod] = useState({open: false, newPriceId: null});
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [directPaymentSuccess, setDirectPaymentSuccess] = useState(false);
  const [partnerConfrimation, setPartnerConfrimation] = useState({open: false, phases: null});
  const [temptPaymentData, setTemptPaymentData] = useState({
    open: false,
    newPriceId: existingPaymentMethod?.newPriceId,
    newAmounts: null,
    data: null,
    daysUsed: 0,
    daysRemaining: 0,
    amountToPay: 0,
    finalAmountDue: 0,
    creditAmounts: 0,
    planUnitAmount: 0,
    billingLabel: "",
    plansDetail: null,
  });
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const { toast } = useToast();
  const ENV = process.env.REACT_APP_CUSTOM_ENV || "dev";
  const isMobile = useMediaQuery('(max-width:767px)');

  const promocodes = [
    "FP26-K7M9",
    "FP26-X3N8",
    "FP26-Q9L4",
    "FP26-H2P7",
    "FP26-V6C1",
    "FP26-T5R3",
    "FP26-W8J2",
    "FP26-F4B9",
    "FP26-M1D6",
    "FP26-A7K5",
    "FP26-Z3G8",
    "FP26-N9H2",
    "FP26-S6L4",
    "FP26-B2X7",
    "FP26-C8V1",
    "FP26-Y4Q9",
    "FP26-P3W6",
    "FP26-R7T5",
    "FP26-J1M8",
    "FP26-D5N3",
    "FP26-K9X2",
    "FP26-V4H7",
    "FP26-Q6B1",
    "FP26-W2R8",
    "FP26-T7L5",
    "FP26-M3C9",
    "FP26-H8J4",
    "FP26-X1G6",
    "FP26-N5P2",
    "FP26-S9K7",
    "FP26-B4D3",
    "FP26-A6V8",
    "FP26-Z2W1",
    "FP26-R5T4",
    "FP26-L7M9",
    "FP26-C3N6",
    "FP26-Y8Q2",
    "FP26-P1H5",
    "FP26-K4X7",
    "FP26-J9B3",
    "FP26-D6G8",
    "FP26-V2L1",
    "FP26-W7R4",
    "FP26-T3C9",
    "FP26-M8J5",
    "FP26-H1N2",
    "FP26-X6P7",
    "FP26-Q4K3",
    "FP26-S2B6",
    "FP26-F5D8",
  ]

  const PRODUCT_LIMITS = {
    "standard": { userLimit: 5, storageLimits: 50 * 1024 * 1024 * 1024 },
    "plus": { userLimit: 10, storageLimits: 100 * 1024 * 1024 * 1024 },
    "professional": { userLimit: 20, storageLimits: 200 * 1024 * 1024 * 1024 },
    "users plan": { userLimit: 9999, storageLimits: 0 }
  };

  const downgradeAccess = async (id) => {
    const allPrices = [...(prices || []), ...(yearlyPrice || [])];
    const priceObj = allPrices.find(p => p.id === id);
    
    if (!priceObj) return { userLimit: 0, storageLimits: 0, id };

    const productName = priceObj.product?.name?.toLowerCase();
    const limits = PRODUCT_LIMITS[productName] || { userLimit: 0, storageLimits: 0 };

    return {
      ...limits,
      id,
    };
  };

  // eslint-disable-next-line no-unused-vars
  function getPriceDisplay(priceId) {
    const priceObj = prices.find((p) => p.id === priceId);
    if (!priceObj) return null;
    const adjustedAmount = priceObj.unit_amount * 10;
    const oldAmount = (adjustedAmount / 100).toFixed(2);
    const newAmount = (adjustedAmount / 12 / 100).toFixed(2);
    return { oldAmount, newAmount };
  }

  function getPriceDisplayPrice(priceId) {
    const priceObj =
      prices.find((p) => p.id === priceId) ||
      yearlyPrice.find((p) => p.id === priceId);

    if (!priceObj) return null;
    const newAmount = priceObj.unit_amount.toFixed(2);
    return newAmount;
  }

  useEffect(() => {
    const loadStripeConfig = async () => {
      commonContext?.setLoader(true);
      // const result = await getStripeConfigs();
      const allPrices = await getAllProducts();

      const activePrices = allPrices?.filter((p) => p.active === true && p.unit_amount > 0 && ["Standard", "Plus", "Professional"].includes(p.product?.name));
      activePrices?.sort((a, b) => a.unit_amount - b.unit_amount);

      const sorted = activePrices?.filter((p) => p.recurring?.interval === "month");
      const sortedYearly = activePrices?.filter((p) => p.recurring?.interval === "year");

      setPrices(sorted);
      setYearlyPrices(sortedYearly);

      commonContext?.setLoader(false);
    };

    loadStripeConfig();
  }, []);

  useEffect(() => {
    const fetchCustomerBalance = async () => {
      try {
        const customerID = auth?.userProfile?.customer;
        if (!customerID) return;

        const [balance] = await Promise.all([
          getCustomerBalanceAmount(customerID),
        ]);

        setCustomerBalance(balance);
        const cardsData = auth?.userProfile?.cardsData?.cards?.filter((item) => item?.status !== "pending") || [];
        setPaymentMethods({
          defaultPaymentMethodId: auth?.userProfile?.cardsData?.defaultPaymentMethodId || null,
          cards: cardsData,
        });
      } catch (error) {
        console.error("Failed to fetch customer balance:", error);
      }
    };

    fetchCustomerBalance();
  }, [auth?.userProfile?.customer, auth?.userProfile?.cardsData]);

  // useEffect(() => {
  //   const interval = auth?.userProfile?.subscriptionDetails?.plan?.interval;
  //   if (!interval) {
  //     setIsAnnual(true);
  //   } else {
  //     setIsAnnual(interval === "year");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []); // auth?.userProfile?.subscriptionDetails?.plan?.interval is stable

  useEffect(() => {
    if (auth?.userProfile?.subscriptionDetails?.plan?.interval === "year") {
      setIsAnnual(true);
    } else {
      setIsAnnual(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // auth?.userProfile?.subscriptionDetails?.plan?.interval is stable

  const handleNavigate = () => {
    navigate("/dashboard");
    setDirectPaymentSuccess(false);
    setPaymentSuccess(false);
    setNewPriceId();
    auth?.setsubstatus(false);
    window.location.reload();
  };

  const handleCloseDetailsDowngrade = () => {
    setDowngradeDetailsDialog(false);
    setSubChangeDialog(false);
    setClientSecret(null);
    setNewPrice(null);
    navigate("/dashboard");
    setDetails(null);
    setPaymentSuccess(false);
    setNewPriceId();
    window.location.reload();
  };

  const handleCloseDowngrade = () => {
    setDownGradeDialog(false);
    setMessage("");
  };

  const handleQuantityStripeSubscription = async () => {
    commonContext?.setLoader(true);
    const customerId = auth?.userProfile?.customer;
    const result = await UpgradeQuantitySubscription(
      customerId,
      newPrice,
      code,
      numUsers
    );
    commonContext?.setLoader(false);
    if (result?.status === 200) {
      const { amount } = await getAmounts(result?.data?.clientSecret);
      setNewAmounts(amount);
      setNewPriceId(newPrice);
      setClientSecret(result?.data);
    } else {
      setClientSecret(null);
      setNewAmounts();
    }
  };

  const getConfirmationContent = (phaseIndex) => {
  switch (phaseIndex) {
    case 0:
      return {
        title: "Update Subscription (Free Phase)",
        message: `
          Your subscription will be updated immediately.

          You are currently in the FREE phase, so you will NOT be charged at this time.

          Your new plan will take effect right away. After the update, you will be redirected to your dashboard.

          Are you sure you want to continue?
        `
      };

    case 1:
      return {
        title: "Update Subscription (Active Paid Phase)",
        message: `
          Your subscription will be updated immediately.

          You are currently in an active paid phase.

          Any remaining amount will be automatically adjusted in your next invoice (prorated accordingly).

          After the update is completed, you will be redirected to your dashboard.

          Are you sure you want to continue?
        `
      };

    case 2:
      return {
        title: "Update Subscription (Lifetime Phase)",
        message: `
          Your subscription will be updated immediately.

          You are currently in the lifetime phase. No immediate charge will occur.

          If any billing adjustments apply, they will reflect in your next invoice.

          After the update, you will be redirected to your dashboard.

          Are you sure you want to continue?
        `
      };

    default:
      return {
        title: "Update Subscription",
        message: `
          Your subscription will be updated immediately.

          After the update, you will be redirected to your dashboard.

          Are you sure you want to continue?
        `
      };
  }
};

  const handleUpdateStripeSubscription = async (newPriceId, productId) => {
    const customerCode = auth?.userProfile?.userPromoCode;
    if (customerCode && typeof customerCode === "string" && customerCode.startsWith("FP26") && paymentMethods && paymentMethods?.cards?.length > 0) {
      commonContext?.setLoader(true);
      const subscriptionId = auth?.userProfile?.subscriptionDetails?.scheduleId || auth?.userProfile?.subscriptions?.data?.[0]?.scheduleId;
      const phases = await getCurrentPhase(subscriptionId);
      setNewPriceId(newPriceId);
      setNewProduct(productId);
      setPartnerConfrimation({open: true, phases: phases});
      commonContext?.setLoader(false);
      return;
    } else if (code && code.startsWith("FP26")) {
      commonContext?.setLoader(true);
      const customerId = auth?.userProfile?.customer;
      const setUpIntent = await gettheSetupIntent(customerId);
      setClientSecret(setUpIntent?.data?.clientSecret);
      setNewPriceId(newPriceId);
      setNewProduct(productId);
      setNewAmounts(0);
      commonContext?.setLoader(false);
      return;
    } else {
    try {
      commonContext?.setLoader(true);
  
      const status = auth?.userProfile?.subscriptionDetails?.status || auth?.userProfile?.subscriptions?.data?.status;
      const customerId = auth?.userProfile?.customer;
      const subscriptionId = auth?.userProfile?.subscriptionDetails?.id ||
        auth?.userProfile?.subscriptions?.data?.[0]?.id;
  
      if (status === "canceled") {
        if (paymentMethods && paymentMethods?.cards?.length > 0) {
          setExistinPaymentMethod({ open: true, newPriceId: newPriceId });
          return;
        } else {
          const result = await createNewSubscriptionAfterCancel(customerId, newPriceId, code);

          if (result?.status === 200) {
            const { amount } = await getAmounts(result?.data?.clientSecret);
            setNewAmounts(amount);
            setNewPriceId(newPriceId);
            setClientSecret(result?.data);
          }

          return;
        }
      }

      const storage = auth?.userProfile?.storage || 0;
      const userLimit = auth?.userProfile?.companyActiveUsers || 0;
      const currentPlanId = auth?.userProfile?.subscriptions?.data?.[0]?.plan?.id;
  
      const [newPlan, oldPlan] = await Promise.all([
        downgradeAccess(newPriceId),
        downgradeAccess(currentPlanId),
      ]);
          
      const exceedsStorage = storage > newPlan?.storageLimits;
      const exceedsUsers = userLimit > newPlan?.userLimit;
  
      const isDowngrade = newPlan?.userLimit < oldPlan?.userLimit;
      const usersToDisable = userLimit - newPlan?.userLimit;
      if (isDowngrade && (exceedsStorage || exceedsUsers)) {
        const message = exceedsStorage
          ? "Your current storage usage exceeds the limit of the selected plan. Please reduce your storage before downgrading."
          : `Your company currently has ${userLimit} active users, which exceeds the limit of ${newPlan?.userLimit} allowed by the selected plan. Please disable ${usersToDisable} user(s) to proceed with the downgrade.`;
        setMessage(message);
        setDownGradeDialog(true);
        return;
      }

      const data = await calculateSubscriptionPayment(subscriptionId, newPriceId, code);

      if (data?.finalAmountDue > 0) {
        if (paymentMethods && paymentMethods?.cards?.length > 0) {
          setExistinPaymentMethod({open: true, newPriceId: newPriceId});
          return;
        } else {
          const result = await UpgradeStripeSubscription(subscriptionId, newPriceId, code);

          if (result?.status === 200) {
            const { amount } = await getAmounts(result?.data?.clientSecret);
            setNewAmounts(amount);
            setNewPriceId(newPriceId);
            setClientSecret(result?.data);
          }
        }

        commonContext?.setLoader(false);
        return;
      }

      const result = await UpgradeStripeSubscription(subscriptionId, newPriceId, code);
        if (result?.status === 200 && result?.downgrade === true) {
          const formData = {
            email: auth?.userProfile?.email,
            name: auth?.userProfile?.firstName,
            companyName: auth?.userProfile?.companyName,
          };

          await delay(5500);
          await SuccesDownGradeEmail(formData, result?.data, subscriptionId);

          setDowngradeDetailsDialog(true);
          setDetails(result?.data);
        } else if (result?.status === 200 && result?.switch === true) {
          const formData = {
            email: auth?.userProfile?.email,
            name: auth?.userProfile?.firstName,
          }
          await delay(5500);
          await SuccesUpdateSubscriptionEmail(formData);

          setSubChangeDialog(true);
        }
    } catch (error) {
      console.error("Subscription update failed:", error);
      resetBillingState();
    } finally {
      commonContext?.setLoader(false);
    }
  }
};

const handleConfirmPartnerConfirmation = async () => {
  try {
    commonContext?.setLoader(true);
    setPartnerConfrimation({ open: false, phases: null });
    const subscriptionId =
      auth?.userProfile?.subscriptionDetails?.id ||
      auth?.userProfile?.subscriptions?.data?.[0]?.id;
    const selectedProductId = newProduct;
    const normalPrice = newPriceId;

    const result = await UpdateStripeScheduleSubscription(
      subscriptionId,
      selectedProductId,
      normalPrice,
    );
    if (result?.status) {
      setPartnerConfrimation({ open: false, phases: null });

      toast({
        title: "Success",
        description: "Subscription updated successfully!",
      });

      setTimeout(() => {
        navigate("/dashboard");
      }, 2000);
      window.location.reload();
      commonContext?.setLoader(false);
    } else {
      toast({
        title: "Error",
        description: result?.message || "Something went wrong.",
        variant: "destructive",
      });

      commonContext?.setLoader(false);
    }
  } catch (error) {
    commonContext?.setLoader(false);
    console.error(error);
    toast({
      title: "Error",
      description: "Something went wrong.",
      variant: "destructive",
    });
  }
};

  const handleConfirmPaymentList = async () => {
    const subscriptionId = auth?.userProfile?.subscriptionDetails?.id || auth?.userProfile?.subscriptions?.data?.[0]?.id;
    const status = auth?.userProfile?.subscriptionDetails?.status || auth?.userProfile?.subscriptions?.data?.status;
    const customerId = auth?.userProfile?.customer;

    let result;
    if (status === "canceled") {
      result = await createNewSubscriptionAfterCancel(customerId, existingPaymentMethod?.newPriceId, code);
    } else { 
      result = await UpgradeStripeSubscription(subscriptionId, existingPaymentMethod?.newPriceId, code);
    }

    const { amount } = await getAmounts(result?.data?.clientSecret);

    const priceId = newPrice || existingPaymentMethod?.newPriceId;
    
    const daysUsed = result?.data?.daysUsed ?? 0;
    const plan = isAnnual ? yearlyPrice : prices;

    const plansDetail = plan?.find((item) => item.id === priceId);
    const daysRemaining = result?.data?.daysRemaining ?? (plansDetail?.recurring?.interval === "year" ? 365 - daysUsed : 30 - daysUsed); 
    const amountToPay = result?.data?.amountToPay ?? result?.data?.finalAmountDue ?? 0; 
    const finalAmountDue = result?.data?.finalAmountDue ?? amountToPay; 
    const creditAmounts = (result?.data?.creditFromOldPlan ?? 0) - (result?.data?.creditFromOldSubscription ?? 0); 
    const planUnitAmount = plansDetail?.unit_amount ?? 0; 
    const billingLabel = plansDetail?.recurring?.interval === "month" ? "Monthly" : "Annual (Save 16.67%)";
     setTemptPaymentData({
      open: true,
      newPriceId: existingPaymentMethod?.newPriceId,
      newAmounts: amount,
      data: result?.data,
      daysUsed,
      daysRemaining,
      amountToPay,
      finalAmountDue,
      creditAmounts,
      planUnitAmount,
      billingLabel,
      plansDetail,
    });
    setIsProcessing(false);
  }
  
  const resetBillingState = () => {
    setClientSecret(null);
    setNewPriceId(null);
    setNewAmounts(null);
  };
  

  const handleBillingToggle = () => {
    setIsAnnual(!isAnnual);
  };

  const handleApply = async () => {
    try {
      if (!code?.trim()) return;

      const trimmedCode = code.trim();

      const userPromo = auth?.userProfile?.userPromoCode;

      if (userPromo?.includes(trimmedCode)) {
        toast({
          title: "Already Used",
          description: "You have already used this promo code.",
          variant: "destructive",
        });

        return;
      }

      if (promocodes.includes(trimmedCode)) {

        setIsFullDiscount(true);
        const priceDetails = {};

        const productNames = new Set([
          ...(prices?.map(p => p.product?.name) || []),
          ...(yearlyPrice?.map(p => p.product?.name) || []),
        ]);

        productNames.forEach(planName => {
          priceDetails[planName] = {
            monthly: 0,
            yearly: 0,
          };
        });
        setPriceState(priceDetails);

        toast({
          title: "Success",
          description: "100% discount applied!",
        });

        return;
      }

      toast({
        title: "Invalid",
        description: "Invalid promo code.",
        variant: "destructive",
      });
    } catch (error) {
      console.error(error);
    }
  };

  // const handleApply = async () => {
  //   commonContext?.setLoader(true);
  //   try {
  //     const priceDetails = {};
  //     let discountData = null;

  //     if (code) {
  //       discountData = await getPromotionCodes(code);

  //       if (!discountData) {
  //         commonContext?.setLoader(false);
  //         toast({
  //           title: "Error",
  //           description: "Invalid promo code.",
  //           variant: "destructive",
  //         });
  //         setCode();
  //         return;
  //       }
  //     }

  //     const products = new Set([...prices?.map(p => p.product?.name), ...yearlyPrice?.map(p => p.product?.name)]);

  //     products.forEach(planName => {
  //       const monthlyPriceObj = prices?.find(p => p.product?.name === planName);
  //       const yearlyPriceObj = yearlyPrice?.find(p => p.product?.name === planName);

  //       const monthlyAmount = monthlyPriceObj ? monthlyPriceObj.unit_amount : 0;
  //       const yearlyAmount = yearlyPriceObj ? yearlyPriceObj.unit_amount : 0;

  //       let discountedMonthlyPrice = monthlyAmount;
  //       let discountedYearlyPrice = yearlyAmount;

  //       if (discountData) {
  //         if (discountData.type === "amount") {
  //           discountedMonthlyPrice = (
  //             monthlyAmount -
  //             discountData.value / 100
  //           ).toFixed(2);
  //           discountedYearlyPrice = (
  //             yearlyAmount -
  //             discountData.value / 100
  //           ).toFixed(2);
  //         } else if (discountData.type === "percent") {
  //           discountedMonthlyPrice = (
  //             monthlyAmount *
  //             (1 - discountData.value / 100)
  //           ).toFixed(2);
  //           discountedYearlyPrice = (
  //             yearlyAmount *
  //             (1 - discountData.value / 100)
  //           ).toFixed(2);
  //         }
  //       }

  //       priceDetails[planName] = {
  //         monthly: discountedMonthlyPrice,
  //         yearly: discountedYearlyPrice,
  //       };
  //     });
  //     setPriceState(priceDetails);
  //     commonContext?.setLoader(false);
  //     return priceDetails;
  //   } catch (error) {
  //     console.error("Error applying discount:", error);
  //     commonContext?.setLoader(false);
  //   }
  // };

  const handleVerificationSuccess = async () => {
    try {
      const customerId = auth?.userProfile?.customer;
      const pendingData = auth?.userProfile?.pendingVerifications?.[0] || {};

      const verificationDocId = pendingData?.id;
      const newPriceId = pendingData?.newPriceId;
      const newAmounts = pendingData?.newAmounts;

      if (!verificationDocId) {
        console.error("Missing verification document ID");
        setVerificationLoader(false);
        return;
      }

      await Promise.all([
        updatePaymentVerification(verificationDocId),
        sendEmailForAchPaymentDetail(newPriceId, customerId, newAmounts)
      ]);

      toast?.({
        title: "Bank Account Verified",
        description:
          "Your bank account has been successfully verified. ACH payment is now processing.",
        variant: "default",
      });

      setVerificationRequired({
        open: false,
        type: null,
        paymentIntentId: null,
        setUpIntentId: null,
      });
      setPaymentSuccess(true);
      setNewPriceId();
    } catch (error) {
      console.error("ACH verification failed:", error);
    } finally {
      setVerificationLoader(false);
    }
  };

  return (
    <>
    {directPaymentSuccess === false && (
      <PageTitle
        pageTitle="Plans"
        showBreadcrumb={[{ label: "Home", to: "/" }, { label: "Account" }]}
        BreadCrumbCurrentPageTitle={"Plans"}
        showLastSeen={true}
      />
      )}
      <div className="px-4 py-5 md:p-25">
        {directPaymentSuccess === false ? (
        newPriceId === null ? (
          <>
            {auth?.userProfile?.pendingVerifications &&
              auth?.userProfile?.pendingVerifications?.length > 0 && (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "12px 16px",
                      background: "#FFF4E5",
                      border: "1px solid #F4A261",
                      borderRadius: "8px",
                      marginTop: "10px",
                      marginBottom: "20px",
                      width: "fit-content",
                      gap: "12px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#7A4E00",
                      }}
                    >
                      Your bank account needs verification before we can process
                      your subscription.
                    </span>

                    <Button
                      variant="contained"
                      onClick={() => {
                        setVerificationRequired({
                          open: true,
                          type: auth?.userProfile?.pendingVerifications?.[0]
                            ?.verificationType,
                          paymentIntentId:
                            auth?.userProfile?.pendingVerifications?.[0]
                              ?.paymentIntentId,
                          setUpIntentId:
                          auth?.userProfile?.pendingVerifications?.[0]
                              ?.setUpIntentId,
                        });
                      }}
                      style={{
                        backgroundColor: "#16A34A",
                        color: "white",
                        padding: "6px 16px",
                        textTransform: "none",
                      }}
                    >
                      {verificationLoader ? (
                        <CircularProgress
                          size={28}
                          style={{ color: "white" }}
                        />
                      ) : (
                        "Verify Now"
                      )}
                    </Button>
                  </div>
                </div>
              )}

            <div className="bg-white dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:text-white rounded-xl shadow-sm p-24 text-center md:text-left">
            <h1 className="text-xl md:text-2xl font-semibold leading-tight">
              Select The Best Plan For Your Business
            </h1>

            <p className="mt-12 text-sm md:text-base text-gray-600 dark:text-[#6B7280]">
              Join thousands of businesses that trust Pro Teams to manage their
              operations effectively. Unlock all features and take your
              business to the next level.
            </p>
          </div>

            <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between mt-24">
  
              <div className="w-full md:w-auto bg-white dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:text-white rounded-xl shadow-sm p-16">
                <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
                  
                  <span className={`text-sm font-medium ${!isAnnual ? "text-green-600" : "text-gray-400"}`}>
                    Monthly
                  </span>

                  <AntSwitch
                    checked={isAnnual}
                    onChange={handleBillingToggle}
                    color="primary"
                  />

                  <span className={`text-sm font-medium ${isAnnual ? "text-green-600" : "text-gray-400"}`}>
                    Annual
                  </span>

                  <span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded-md">
                    Save 17%
                  </span>
                </div>
              </div>

              <div className="w-full md:w-auto bg-white dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:text-white rounded-xl shadow-sm p-16">
                <div className="flex flex-col md:flex-row md:items-center gap-3">

                  <span className="text-sm font-medium text-gray-600 dark:text-gray-400 whitespace-nowrap">
                    Have a promo code?
                  </span>

                  <div className="flex w-full md:w-auto gap-2">

                    <input
                      type="text"
                      placeholder="Enter code"
                      value={code}
                      onChange={(e) => {
                        const value = e.target.value;
                        setCode(value);
                        setIsFullDiscount(false);
                      }}
                      className="flex-1 px-4 h-10 rounded-md border 
                                border-gray-300 
                                focus:outline-none focus:ring-2 
                                focus:ring-green-500 
                                bg-white 
                                dark:bg-[#1A1F2C] 
                                text-black 
                                dark:text-white"
                    />

                    <button
                      onClick={handleApply}
                      disabled={!code?.trim()}
                      className="h-10 px-5 rounded-md 
                                bg-green-600 
                                hover:bg-green-700 
                                text-white 
                                font-medium 
                                transition 
                                disabled:opacity-50"
                    >
                      Apply
                    </button>

                  </div>
                </div>
              </div>

            </div>

            <SubscriptionList
              prices={prices}
              isAnnual={isAnnual}
              yearlyPrice={yearlyPrice}
              numUsers={numUsers}
              setNewPrice={setNewPrice}
              setNewProduct={setNewProduct}
              newProduct={newProduct}
              setNewPriceId={setNewPriceId}
              handleUpdateStripeSubscription={handleUpdateStripeSubscription}
              loader={loader}
              priceState={priceState}
              customerBalance={customerBalance}
              newPrice={newPrice}
              setPlanInfo={setPlanInfo}
              isFullDiscount={isFullDiscount}
            />

            <FeatureComparison isOpen={isOpen} setIsOpen={setIsOpen} />

            <TestimonialPage />
          </>
        ) : (
          <Elements stripe={stripePromise}>
            <PaymentFlowContet
              plan={isAnnual ? yearlyPrice : prices}
              loader={loader}
              setName={setName}
              name={name}
              // handleSubmit={handleSubmit}
              newPrice={newPrice}
              newAmounts={newAmounts}
              setClientSecret={setClientSecret}
              clientSecret={clientSecret}
              handleQuantityStripeSubscription={
                handleQuantityStripeSubscription
              }
              setNumUsers={setNumUsers}
              numUsers={numUsers}
              priceState={priceState}
              paymentSuccess={paymentSuccess}
              setPaymentSuccess={setPaymentSuccess}
              handleNavigate={handleNavigate}
              setLoader={setLoader}
              newPriceId={newPriceId}
              setNewPriceId={setNewPriceId}
              verificationRequired={verificationRequired}
              setVerificationRequired={setVerificationRequired}
              code={code}
              isFullDiscount={isFullDiscount}
              newProduct={newProduct}
            />
          </Elements>
        )) : (
          <PaymentSuccess
            handleNavigate={handleNavigate}
            plansDetail={temptPaymentData?.plansDetail}
            paymentMethod={selectedPaymentMethod?.type}
          />
        )}
      </div>
      {downgradeDialog && (
        <DownGradeDiaog
          open={downgradeDialog}
          onClose={handleCloseDowngrade}
          message={message}
        />
      )}
      {downgradeDetailsDialog && (
        <SuccessDowngradeDialog
          open={downgradeDetailsDialog}
          onClose={handleCloseDetailsDowngrade}
          data={details}
          change={false}
        />
      )}
      {subChangeDialog && (
        <SuccessDowngradeDialog
          open={subChangeDialog}
          onClose={handleCloseDetailsDowngrade}
          data={details}
          change={true}
        />
      )}

      {partnerConfrimation?.open && (
        <CommonConfirmationDialog
          open={partnerConfrimation?.open}
          onConfirm={handleConfirmPartnerConfirmation}
          onClose={() => setPartnerConfrimation({ open: false, phases: null })}
          title={
            getConfirmationContent(
              partnerConfrimation?.phases?.currentPhaseIndex
            ).title
          }
          message={
            getConfirmationContent(
              partnerConfrimation?.phases?.currentPhaseIndex
            ).message
          }
          buttonTitle="Confirm Update"
        />
      )}


      {verificationRequired?.open && (
        <ACHVerification
          open={verificationRequired?.open}
          type={verificationRequired?.type}
          paymentIntentId={verificationRequired?.paymentIntentId}
          setUpIntentId={verificationRequired?.setUpIntentId}
          onSuccess={handleVerificationSuccess}
          onClose={() =>
            setVerificationRequired({
              open: false,
              type: null,
              paymentIntentId: null,
              setUpIntentId: null,
            })
          }
          verificationLoader={verificationLoader}
          setVerificationLoader={setVerificationLoader}
        />
      )}

      {existingPaymentMethod?.open && (
        <Elements stripe={stripePromise}>
        <PaymentMethodsList
          open={existingPaymentMethod?.open}
          onClose={() => { setExistinPaymentMethod({open: false, newPriceId: null}); setPlanInfo({planName: null, description: null, amount: null, yearly: false}); }}
          onConfirm={() => handleConfirmPaymentList()}
          paymentMethods={paymentMethods}
          planInfo={planInfo}
          temptPaymentData={temptPaymentData}
          setTemptPaymentData={setTemptPaymentData}
          setSelectedPaymentMethodId={setSelectedPaymentMethodId}
          selectedPaymentmethodId={selectedPaymentmethodId}
          setIsProcessing={setIsProcessing}
          isProcessing={isProcessing}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          selectedPaymentMethod={selectedPaymentMethod}
          setPaymentSuccess={setDirectPaymentSuccess}
        />
        </Elements>
      )}
    </>
  );
};

export default UpgradePage;
